import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const buttonDefinition: ComponentDefinition = {
  id: 'button-experience',
  name: 'Button',
  category: 'UI',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/rectangle-horizontal.svg',
  variables: {
    label: {
      displayName: 'Label',
      type: 'Text',
      defaultValue: 'Button',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },

    href: {
      displayName: 'Link',
      type: 'Text',
      defaultValue: '#',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },

    target: {
      displayName: 'Open in new tab?',
      type: 'Boolean',
      defaultValue: false,
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },

    buttonStyle: {
      displayName: 'Button style',
      type: 'Text',
      defaultValue: 'primary',
      group: 'style',
      validations: {
        in: [
          { value: 'primary', displayName: 'Primary' },
          { value: 'secondary', displayName: 'Secondary' },
        ],
      },
    },

    withArrow: {
      displayName: 'With arrow',
      type: 'Boolean',
      defaultValue: false,
      group: 'style',
    },

    hoverUp: {
      displayName: 'Move up on hover',
      type: 'Boolean',
      defaultValue: true,
      group: 'style',
    },

    disabled: {
      displayName: 'Disabled',
      type: 'Boolean',
      defaultValue: false,
      group: 'style',
    },

    fontSize: {
      displayName: 'Font size (px)',
      type: 'Number',
      defaultValue: 16,
      group: 'style',
    },

    paddingX: {
      displayName: 'Padding X (px)',
      type: 'Number',
      defaultValue: 48,
      group: 'style',
    },

    paddingY: {
      displayName: 'Padding Y (px)',
      type: 'Number',
      defaultValue: 12,
      group: 'style',
    },

    customWidth: {
      displayName: 'Custom width (px)',
      type: 'Number',
      group: 'style',
    },

    fullWidth: {
      displayName: 'Full width',
      type: 'Boolean',
      defaultValue: false,
      group: 'style',
    },
  },
} as const;
